import styled from "styled-components";

export const PopupOverlay = styled.div`
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1045;
`;

export const PopupContainer = styled.div`
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  gap: 20px;
  position: fixed;
  top: 85px;
  right: 12px;
  width: 366px;
  background: #ffffff;
  border: 1px solid #b4c6f9;
  box-shadow: 0px 4px 20px rgba(34, 102, 239, 0.15);
  border-radius: 8px;
  z-index: 1046;
  box-sizing: border-box;
`;

/* ── User header card ── */
export const UserHeaderCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  width: 100%;
  height: 60px;
  background: linear-gradient(90deg, #f4ecfe 0%, #edf8fe 100%);
  border-radius: 4px;
  flex-shrink: 0;
  box-sizing: border-box;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const UserAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

export const UserAvatarInitials = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${({ color }) => color || "#3b3f48"};
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const UserTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const UserName = styled.span`
  font-family: "Mona Sans", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #000e2a;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;

`;

export const UserEmail = styled.span`
  font-family: "Mona Sans", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #000e2a;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;

`;

export const LanguageDropdownWrapper = styled.div`
  position: relative;
  width: 100px;
`;

export const LanguageButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 5px 8px;
  gap: 6px;
  background: #ffffff;
  border: 1px solid #b4c6f9;
  border-radius: 8px;
  cursor: pointer;
  font-family: "Mona Sans", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #000e2a;
  white-space: nowrap;
`;

export const LanguageArrow = styled.img`
  width: 16px;
  height: 16px;
`;

export const LanguageDropdown = styled.div`
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  flex-direction: column;
  position: absolute;
  top: 100%;
  right: 0;
  background: #ffffff;
  border: 1px solid #b4c6f9;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(34, 102, 239, 0.1);
  margin-top: 4px;
  z-index: 1047;
  min-width: 120px;
  overflow: hidden;
`;

export const LanguageOption = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  font-family: "Mona Sans", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #000e2a;
  background: #ffffff;
  transition: background 0.12s;

  &:hover {
    background: #f4f6f9;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f0f2f5;
  }
`;

/* ── Organizations section ── */
export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

export const SectionLabel = styled.span`
  font-family: "Mona Sans", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #353a46;
`;

export const OrgItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px 8px 8px;
  gap: 8px;
  width: 100%;
  min-height: 48px;
  border: ${({ selected }) => (selected ? "1px solid #2266ef" : "1px solid transparent")};
  background: ${({ selected }) => (selected ? "transparent" : "#ffffff")};
  border-radius: 8px;
  cursor: pointer;
  box-sizing: border-box;
  transition: background 0.12s;

  &:hover {
    background: ${({ selected }) => (selected ? "transparent" : "#f4f6f9")};
  }
`;

export const OrgItemInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const OrgBadge = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${({ bgColor }) => bgColor || "#9e9e9e"};
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const OrgName = styled.span`
  font-family: "Mona Sans", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #000e2a;
`;

/* Blue tick checkmark for active org */
export const SelectedOrgTick = styled.div`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2266ef;
`;

/* ── Divider ── */
export const Divider = styled.div`
  width: 100%;
  height: 1px;
  border: 1px solid #d3e0fc;
`;

/* ── Archived section ── */
export const ArchivedHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

export const ArchivedLink = styled.a`
  font-family: "Mona Sans", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #2266ef;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

/* ── Footer buttons ── */
export const FooterRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const FooterButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px;
  gap: 10px;
  flex: 1;
  height: 32px;
  background: #ffffff;
  border: ${({ primary }) => (primary ? "1px solid #2266ef" : "1px solid #a7c2f9")};
  border-radius: 32px;
  cursor: pointer;
  font-family: "Mona Sans", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #2266ef;
  transition: background 0.12s;

  &:hover {
    background: #f0f4ff;
  }
`;
